// The server marks an announcement seen only once the impression is submitted, at the end
// of the exposure, so what the popup has already shown is held here until a poll agrees.
export class SeenAnnouncements {
    constructor() {
        this.documentIds = new Set()
    }

    remember(announcement) {
        const documentId = announcement?.documentId
        if (documentId == null || this.documentIds.has(documentId)) {
            return false
        }

        this.documentIds.add(documentId)

        return true
    }

    applyTo(announcements = []) {
        return announcements.map((announcement) => (
            this.documentIds.has(announcement.documentId) && !announcement.isSeen
                ? { ...announcement, isSeen: true }
                : announcement
        ))
    }
}
